import MasterICCardStaffSettingForm from './MasterICCardStaffSettingForm';

export default MasterICCardStaffSettingForm;